import type {
  IConfParam,
  ITrackerConstructor,
  TTrackEvt,
  ITrackerClass,
  IFramework,
  IExtraReport,
} from '@/types/wiseTracker.ts';
import type { IBaseTrackData, IDataStore, IParamData } from '@/types/DataStore';
import { DataStore } from './DataStore';
import { getReqInstance } from '@/requestInstance';
import _ from 'lodash';
import { useFlatRes } from '@/utils/basicTool.ts';
import PlatformProxy from './PlatformProxy.ts';

export class WiseTracker implements ITrackerClass {
  private config: IConfParam | undefined;
  private platform: PlatformProxy = PlatformProxy.getInstance();
  private isInited = false;
  private framework: IFramework | null | undefined = null;
  private dataStore: IDataStore | null | undefined;
  private req: any;
  public constructor(opts: ITrackerConstructor) {
    console.log('in tracker constructor', opts);
    this.framework = opts?.framework;
    this.platform.init({ platform: opts?.platform });
    console.log('platform: ', this.platform.platformType);
    this.init(opts);
  }
  /**
   * 埋点
   * @param {String} evtName
   * @param {Object} params
   * @param arg
   */
  public async track(
    evtName: TTrackEvt,
    params?: IParamData,
    ...arg: (undefined | string | IExtraReport)[]
    // extraReport?: IExtraReport,
  ) {
    console.log('evtName: ', evtName, params);

    if (!this.isInited) {
      throw new Error('请先执行 init 方法进行初始化');
    }
    this.dataStore!.setBaseData('action', evtName);
    // if (params) {
    console.log('track params: ', params);
    this.dataStore!.setExtraData('param', params || {});
    // }
    const trackData = this.dataStore!.getFullData();

    if (typeof arg?.[0] === 'string' || params?.eventCode) {
      trackData.eventCode = arg[0] as string;
    } else {
      const _extraReport = arg.find((item) => item?.hasOwnProperty('extraReportBase')) as IExtraReport | undefined;
      if (_extraReport?.extraReportBase) {
        _.assign(trackData, { ..._extraReport.extraReportBase });
      }
    }
    console.log('trackData: ', trackData);
    const [err, res] = await useFlatRes(
      this.req.post({
        data: trackData,
      }),
    );
    if (this.config?.debug) {
      console.log('trackData: ', trackData);
      const baseData = { platform: this.platform.platformType, ...this.config, eventName: evtName };
      console.group('baseData Debug');
      console.table({ ...baseData });
      console.groupEnd();
      console.group('Request Debug');
      console.table({ trackSuccess: res, trackError: err });
      console.groupEnd();
      console.group('trackData Debug');
      console.table({ ...trackData });
      console.groupEnd();
    }
  }
  public insert(opts: IBaseTrackData) {
    console.log('%ctracker Insert', 'background-color: green');
    console.log('insert Opts: ', opts);
    this.dataStore!.setBaseDataObj(opts);
  }
  public setPageDataSnap() {}
  public getConfig() {
    return this.config;
  }
  public getDataStoreInstance() {
    return this.dataStore;
  }
  /**
   * 自动埋点
   * @public
   */
  public autoTrack() {
    console.log('autoTrack: ', this.platform.platformType);
    this.platform.autoTrack({ ...this.framework });
  }
  /**
   * 初始化
   * @param {Object} config
   * @param {String} config.apiUrl - 上报地址
   * @param {String} config.appId - appId
   * @param {Boolean} [config.debug] - 是否开启调试模式
   */
  private init(config: IConfParam) {
    console.log('tracker SDK Initialized', this.platform.platformType);
    if (!config?.apiUrl) {
      console.error('当前入参配置：', config);
      throw new Error('没有提供必要的基础配置信息，缺少url参数');
    }
    this.config = config;
    console.log('config: ', this.config);

    const initDataStore: IBaseTrackData = {
      appId: this.config.appId,
      keyCode: this.config.keyCode,
    };
    this.dataStore = new DataStore(initDataStore, this.config.debug || false);
    this.req = getReqInstance({
      baseUrl: config.apiUrl,
    });
    this.isInited = true;
    console.log('%ctracker Init', 'background-color: green');
  }
}
